export const env = 'uat';